export default "__VITE_ASSET__KCwNe1i8__"